import { api } from './api';

export interface LibraryCard {
    title: string;
    image: string;
    link: string;
    plan_ids?: number[];
}

export interface LibraryRow {
    title: string;
    cards: LibraryCard[];
}

export interface LibraryResponse {
    success: boolean;
    message: string;
    data: LibraryRow[];
}

export const getLibrary = async (): Promise<LibraryRow[]> => {
    const response = await api.get<LibraryResponse | LibraryRow[]>('/library');

    return Array.isArray(response) ? response : response.data;
};
